import { queryKeyFn } from '../../generated/sitContext';
export const timesheetRowsQueryKey = (id) => queryKeyFn({
    path: '/timesheets/{id}/rows',
    operationId: 'getApiTimesheetsByUuidRows',
    variables: {
        pathParams: {
            id,
        },
    },
});
export const timesheetRowQueryKey = (id, timesheetRowId) => queryKeyFn({
    path: '/timesheets/{id}/rows/{timesheetRowId}',
    operationId: 'getApiTimesheetRow',
    variables: {
        pathParams: {
            id,
            timesheetRowId,
        },
    },
});
//# sourceMappingURL=query-key.js.map